import { PdfExportService } from '../../services/export-pdf/pdf-export.service';
var AchooIconTooltipComponent = /** @class */ (function () {
    function AchooIconTooltipComponent(pdfService) {
        this.pdfService = pdfService;
        this.width = 9;
        this.height = 9;
        this.placement = 'bottom';
    }
    AchooIconTooltipComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(AchooIconTooltipComponent.prototype, "widthInPx", {
        get: function () {
            return this.width + "px";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AchooIconTooltipComponent.prototype, "heightInPx", {
        get: function () {
            return this.height + "px";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AchooIconTooltipComponent.prototype, "shouldShowTooltip", {
        get: function () {
            return !this.pdfService.exportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    return AchooIconTooltipComponent;
}());
export { AchooIconTooltipComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-icon-tooltip/achoo-icon-tooltip.component.ts.pre-build-optimizer.js